import type {
	FileInfo,
	File,
	FilePopulated,
	ApiResponse,
} from "@vita-learning/types";

import { revalidate } from "~/shared/utils";

import { resHttpClient as httpClient, type HttpConfig } from "../../config";

import { decodeFile } from "./helpers";

export const createFile = async (file: FileInfo) => {
	const resp = await httpClient.post<ApiResponse<FilePopulated>>(
		"/files",
		file
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	await revalidate("files");

	return decodeFile(resp.data);
};

export const fetchFiles = async (
	url: string,
	config?: HttpConfig
): Promise<FilePopulated[]> => {
	const resp = await httpClient.get<ApiResponse<FilePopulated[] | null>>(
		url,
		config
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return (resp.data || []).map(decodeFile);
};

export const updateFile = async (file: File): Promise<FilePopulated> => {
	const resp = await httpClient.put<ApiResponse<FilePopulated>>(
		`/files/${file.id}`,
		file
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	await revalidate("files");

	return decodeFile(resp.data);
};

export const modifyFileFolder = async (file: File): Promise<FilePopulated> => {
	const resp = await httpClient.patch<ApiResponse<FilePopulated>>(
		`/files/${file.id}/folderId`
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	await revalidate("files");

	return decodeFile(resp.data);
};

export const modifyFileTitle = async (file: File): Promise<FilePopulated> => {
	const resp = await httpClient.patch<ApiResponse<FilePopulated>>(
		`/files${file.id}/title`
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	await revalidate("files");

	return decodeFile(resp.data);
};

export const deleteFile = async (id: string): Promise<void> => {
	const resp = await httpClient.delete<ApiResponse<void>>(`/files/${id}`);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	await revalidate("files");

	return resp.data;
};
